import React, { useContext } from "react";
import { IconButton, Tooltip, styled } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { NotificationContext } from "@common/components/Notification";

export const Filled = styled(IconButton)(({ theme }) => ({
  color: theme.palette.common.grey.light,
  backgroundColor: theme.palette.background.paper,
}));
export const Outlined = styled(IconButton)({
  backgroundColor: "transparent",
  color: "white",
  border: "1px solid white",
});

type CopyLinkVariants = "filled" | "outlined";
const CopyLink = ({
  variant = "filled",
  path,
  ...other
}: {
  variant?: CopyLinkVariants;
  /**
   * Absolute path inside the application to the target location: ex "/assets/accounts" or "/tickets/1501500"
   */
  path?: `/${string}`;
}) => {
  const ButtonComponent = variant === "outlined" ? Outlined : Filled;
  const { t } = useTranslation();
  const { dispatchNotification } = useContext(NotificationContext);

  const handleClick = async () => {
    try {
      const target = path
        ? `${window.location.origin}${path}`
        : window.location.href;
      await navigator.clipboard.writeText(target);
      dispatchNotification({
        title: t("Success"),
        message: t(
          "Current URL has been successfully copied to the clipboard."
        ),
        severity: "success",
      });
    } catch {
      dispatchNotification({
        title: t("Error"),
        message: t(
          "An error occured while copying this page's url to your clipboard."
        ),
      });
    }
  };

  return (
    <Tooltip title={t("Copy current URL")} arrow>
      <ButtonComponent onClick={handleClick} {...other}>
        <ContentCopy />
      </ButtonComponent>
    </Tooltip>
  );
};

export default styled(CopyLink)({});
